import { RemoveScroll } from "react-remove-scroll";
import ReactDom from "react-dom";
import { useTranslation } from "react-i18next";
import { RESET_SUBMIT_STATE } from "../Redux/actions/actions";
import { useDispatch } from "react-redux";
  import {
    RESET_ALL_STATES,
    setVerified,
    setAuthenticated,
} from "../Redux/actions/actions";
import { persistor } from "../Redux/store";

const NotificationModal = ({ open, handleClose, message, error, title }) => {
    const { t } = useTranslation(0);
    const dispatch = useDispatch();
    if (!open) return null;

    const logout = ()=>{
          dispatch({ type: "LOGOUT" });
          dispatch({ type: RESET_ALL_STATES });
          persistor.purge();
    }

    return ReactDom.createPortal(
        <div className='fixed top-0 left-0 right-0 h-screen bg-black/40 overflow-clip'>
            <RemoveScroll className='flex justify-center h-full flex-col p-10 bg-transparent'>
                <div
                    className='h-full w-full z-10 absolute bg-transparent'
                    onClick={() => {
                        dispatch({ type: RESET_SUBMIT_STATE });
                        handleClose();
                    }}
                ></div>
                <div className='bg-white w-full z-50 max-w-[400px] mx-auto gap-3 overflow-clip flex flex-col rounded-md'>
                    <div
                        className={`w-full ${
                            error ? "bg-red-500" : "bg-[lightgreen]"
                        } py-1.5`}
                    >
                        <p className='text-lg text-white font-bold text-center'>
                            {title}
                        </p>
                    </div>

                    <div className='flex flex-col items-center justify-end gap-3 text-black pb-2 px-5 text-center'>
                        <p>
                            {message === "OK" ? (
                                "Your request submission was successful!"
                            ) : (
                                <>
                                    {message?.split(" ").map((word, index) => {
                                        if (word.includes("9779")) {
                                            return (
                                                <a
                                                    key={index}
                                                    href="tel:9779"
                                                    className="text-blue-500 underline hover:text-blue-700"
                                                >
                                                    *9779#{" "}
                                                </a>
                                            );
                                        } else if (word.includes("help")) {
                                            return (
                                                <a
                                                    key={index}
                                                    href="https://id.et/faq"
                                                    className="text-blue-500 underline hover:text-blue-700"
                                                >
                                                    help{" "}
                                                </a>
                                            );
                                        } else {
                                            return word + " ";
                                        }
                                    })}
                                </>
                            )}
                        </p>
                        <p>{error}</p>

                        {
                            <button
                                className='px-5 py-1 text-white rounded-md bg-red-700/90 hover:bg-red-700'
                                type='button'
                                onClick={() => {
                                    dispatch({ type: RESET_SUBMIT_STATE });
                                    handleClose();
                                    logout();
                                }}
                            >
                                Close
                            </button>
                        }
                    </div>
                </div>
            </RemoveScroll>
        </div>,
        document.getElementById("portal")
    );
};

export default NotificationModal;
